module.exports = __webpack_public_path__ + "static/media/delete-icon.13a884cf.svg";